<div class="datetime-picker-cell" [class.edit-mode]="isEditMode">
  <label *ngIf="labelText" class="datetime-label">{{ labelText }}</label>

  <div class="datetime-input-container">
    <!-- Month Range: use Material datepicker with year start view -->
    <ng-container *ngIf="dateTimeMode === 'month_range'; else defaultInput">
      <input
        class="datetime-input"
        [matDatepicker]="monthPicker"
        [value]="selectedDate"
        (dateChange)="onMonthSelected($event)"
        [disabled]="isEditMode"
        [min]="minDate"
        [max]="maxDate"
        [placeholder]="placeholder || 'Select month'"
        readonly
      />
      <mat-datepicker-toggle [for]="monthPicker"></mat-datepicker-toggle>
      <mat-datepicker #monthPicker
        startView="year"
        (monthSelected)="onMonthPickerMonthSelected($event, monthPicker)">
      </mat-datepicker>
    </ng-container>

    <!-- All other modes: HTML5 input -->
    <ng-template #defaultInput>
      <input
        [type]="inputType"
        class="datetime-input"
        [value]="formattedValue"
        (input)="onInputChange($event)"
        (change)="onInputChange($event)"
        [disabled]="isEditMode"
        [min]="minDate ? formatDateForInput(minDate) : null"
        [max]="maxDate ? formatDateForInput(maxDate) : null"
        [placeholder]="placeholder || 'MM/DD/YYYY'"
      />
    </ng-template>

    <!-- Clear Button -->
    <button
      *ngIf="enableClear && selectedDate && !isEditMode"
      class="clear-button"
      type="button"
      (click)="onClearDate()"
      title="Clear date">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <!-- No Selection Display -->
  <div *ngIf="!selectedDate" class="no-selection-display">
    {{ placeholder || 'No ' + dateTimeMode + ' selected' }}
  </div>

</div>
